import Point from '@arcgis/core/geometry/Point';
import { calculateDistance } from '.';
import { createTextSymbol } from '.';
import { formatDistance } from '.';
import { GEOMETRY_TYPES } from '../constants';
import type { Graphic, GraphicInput, GraphicsLayer, Geometry } from '../types';

export const createDistanceLabels = (
  polylineGraphic: Graphic,
  graphicsLayer: GraphicsLayer,
): void => {
  if (polylineGraphic.geometry?.type !== GEOMETRY_TYPES.POLYLINE) return;

  const geometry = polylineGraphic.geometry as Geometry;
  if (!geometry.paths || geometry.paths.length === 0) return;

  const existingLabels: Graphic[] = [];
  graphicsLayer.graphics.forEach((g: Graphic) => {
    if (g.attributes?.isDistanceLabel) {
      existingLabels.push(g);
    }
  });
  existingLabels.forEach((label: Graphic) => {
    graphicsLayer.remove(label);
  });

  const path = geometry.paths[0];
  for (let i = 0; i < path.length - 1; i++) {
    const point1 = path[i];
    const point2 = path[i + 1];

    const distance = calculateDistance(point1, point2);
    if (!distance) continue;
    const formattedDistance = formatDistance(distance);

    const midX = (point1[0] + point2[0]) / 2;
    const midY = (point1[1] + point2[1]) / 2;

    const labelPoint = new Point({
      x: midX,
      y: midY,
      spatialReference: geometry.spatialReference,
    });

    const distanceLabel: GraphicInput = {
      geometry: labelPoint,
      symbol: createTextSymbol(formattedDistance),
      attributes: {
        isDistanceLabel: true,
        segmentIndex: i,
      },
    };

    graphicsLayer.add(distanceLabel);
  }
};
